// src/pages/Resume/Resume.js
import React from 'react';
import './Resume.css';
import { useSettings } from '../../hooks/useSettings';

function Resume() {
  const { settings } = useSettings();

  return (
    <div className="resume-page">
      <div className="resume-content">
        <header className="resume-header">
          {settings.profileImageUrl && (
            <img
              src={settings.profileImageUrl}
              alt="Carl Gathmann"
              className="resume-portrait"
            />
          )}
          <h1>Carl Gathmann</h1>
          <p className="resume-subtitle">Robotics & Autonomous Systems Student</p>
          <div className="resume-contact">
            <a href="mailto:c.gathmann@icloud.com">c.gathmann@icloud.com</a>
            <span>·</span>
            <a href="https://cgathmann.de" target="_blank" rel="noopener noreferrer">Website</a>
            <span>·</span>
            <a href="https://linkedin.com/in/carlgathmann" target="_blank" rel="noopener noreferrer">LinkedIn</a>
            <span>·</span>
            <span>Lübeck, Germany</span>
          </div>
        </header>

        <section className="resume-section">
          <h2>Experience</h2>
          <div className="resume-entry">
            <div className="resume-entry-header">
              <span className="resume-role">Master Internship</span>
              <span className="resume-date">Oct 2025 – present</span>
            </div>
            <div className="resume-org">Fraunhofer IMTE, Lübeck</div>
            <p>Development of a prototype for applying wound paste using a robotic arm. Collaboration with an interdisciplinary team.</p>
          </div>

          <div className="resume-entry">
            <div className="resume-entry-header">
              <span className="resume-role">Research Assistant</span>
              <span className="resume-date">Oct 2023 – Apr 2024</span>
            </div>
            <div className="resume-org">Fraunhofer IMTE, Lübeck</div>
            <p>Bachelor Thesis: Evaluation of a Qualisys motion-capture system for medical-robotic applications. Assessment of accuracy and robustness in the OR environment.</p>
          </div>

          <div className="resume-entry">
            <div className="resume-entry-header">
              <span className="resume-role">Operator</span>
              <span className="resume-date">Jun – Aug 2020</span>
            </div>
            <div className="resume-org">X-Fab, Dresden</div>
            <p>Operation of semiconductor manufacturing systems in a cleanroom environment.</p>
          </div>

          <div className="resume-entry">
            <div className="resume-entry-header">
              <span className="resume-role">Student Internship</span>
              <span className="resume-date">Nov 2015</span>
            </div>
            <div className="resume-org">Thermo Fisher, Regensburg</div>
            <p>Prototype development using AutoCAD, 3D printing, and soldering.</p>
          </div>
        </section>

        <section className="resume-section">
          <h2>Education</h2>
          <div className="resume-entry">
            <div className="resume-entry-header">
              <span className="resume-role">M.Sc. Robotics & Autonomous Systems</span>
              <span className="resume-date">2023 – present</span>
            </div>
            <div className="resume-org">University of Lübeck</div>
          </div>
          <div className="resume-entry">
            <div className="resume-entry-header">
              <span className="resume-role">B.Sc. Robotics & Autonomous Systems</span>
              <span className="resume-date">2019 – 2023</span>
            </div>
            <div className="resume-org">University of Lübeck</div>
          </div>
        </section>

        <section className="resume-section resume-skills-section">
          <h2>Skills</h2>
          <div className="resume-skills">
            <div className="skill-group">
              <span className="skill-label">Languages</span>
              <span>Python, Java, C++</span>
            </div>
            <div className="skill-group">
              <span className="skill-label">Systems</span>
              <span>Linux, MacOS, ROS</span>
            </div>
            <div className="skill-group">
              <span className="skill-label">Tools</span>
              <span>Fusion 360, PCB design, Machine Learning</span>
            </div>
            <div className="skill-group">
              <span className="skill-label">Spoken</span>
              <span>German (native), English (C1)</span>
            </div>
          </div>
        </section>

        {settings.resumePdfUrl && (
          <div className="resume-download">
            <a
              href={settings.resumePdfUrl}
              download="Carl_Gathmann_CV.pdf"
              className="download-btn"
            >
              Download PDF
            </a>
          </div>
        )}
      </div>
    </div>
  );
}

export default Resume;
